import { PropsWithChildren } from "react";
import { SessionProvider } from "next-auth/react";
import { setFetcherAccessToken } from "lib/actions/fetcher";
import { useRouter } from "next/router";
import { useSessionKf } from "components/auth/lib/useSessionKf";
import LoadingFullScreen from "components/elements/Loading/LoadingFullScreen";

export default function AuthProvider({ children }: PropsWithChildren<{}>) {
  return (
    <SessionProvider refetchInterval={25 * 60} refetchOnWindowFocus>
      <SessionLoadedGuard>{children}</SessionLoadedGuard>
    </SessionProvider>
  );
}

function SessionLoadedGuard({ children }: PropsWithChildren<{}>) {
  const { session, status } = useSessionKf();
  const router = useRouter();

  const isLoading = status === "loading" || !router.isReady;

  if (!isLoading) setFetcherAccessToken(session?.accessToken);

  if (isLoading) {
    return (
      <LoadingFullScreen
        delay={500}
        icon="LoadingSpotlightLottie"
        lottieClassName="scale-[0.2]"
      />
    );
  }

  return <>{children}</>;
}
